import React from "react"
import { LABEL, CUSTOM_MESSAGES } from "../../veriables";
import cn from "classnames";
import PropTypes from 'prop-types';

const OrderLoyaltySignUpConfirmation = (props) => {
    const { loyaltyInfo, serverAppTheme,setOrderLoyaltyType, isLandScape } = props;
    return (
      <div className="h-97 w-100 position-relative">
      {!isLandScape &&
      <>
          {(loyaltyInfo.signUpImageUrl || loyaltyInfo.imageUrl) ? (
            <div className="w-100 py-1 h-20 pt-2 pb-1">
            <img
                loading="lazy"
                src={loyaltyInfo.signUpImageUrl || loyaltyInfo.imageUrl}
                alt=""
                style={{ width: "100%", height: "100%" }}
              />{" "}
            </div>
          ) : (
            <>
              {" "}
              {storeImage.imageUrl && (
                <div className="col-12 h-25 px-0 pt-2">
                  <div className="col-12 px-0 h-100">
                    <img
                        loading="lazy"
                      src={storeImage.imageUrl}
                      alt=""
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>
                </div>
              )}
            </>
          )}
          </>}
          <div
            className={cn("col-12 fs-32 fs_32 fw-600 justify-content-center align-items-center mx-0 row text-center", isLandScape ? 'h-90' : 'h-65')}
            style={{
              color: serverAppTheme?.primary_text
            }}
          >
            {CUSTOM_MESSAGES().OLS_SIGN_UP_SUCCESS_TEXT}
          </div>
          <div
            className={cn('text-center d-flex w-100', isLandScape ? 'align-items-center justify-content-center': 'align-self-end position-absolute d-flex align-items-end')}
            style={{ bottom: '0' }}
          >
            <button
              type="button"
              className={cn('btn rounded btn-ripple  od-primary-btn-bg-color od-primary-btn-font-color', isLandScape ? 'w-50 btn44' : 'w-100 btn68')}
              onClick={() => setOrderLoyaltyType(5)}
            >
              <div
                className={"fs_28 fw-600"}
              >
                {LABEL().OLS_CONTINUE}
              </div>
            </button>
          </div>
      </div>
    )
}

OrderLoyaltySignUpConfirmation.propTypes = {
  loyaltyInfo: PropTypes.object,        // use shape({...}) if structure is known
  serverAppTheme: PropTypes.string,

  setOrderLoyaltyType: PropTypes.func.isRequired,

  isLandScape: PropTypes.bool,
};

OrderLoyaltySignUpConfirmation.defaultProps = {
  loyaltyInfo: {},
  isLandScape: false,
};


export default OrderLoyaltySignUpConfirmation;